import { useEffect, useState } from 'react';

/** Dieselbe Media-Query wie der `touch`-Custom-Variant in globals.css — JS-Pendant für Fälle, die eine echte Prop steuern (nicht nur Klassen). */
export const TOUCH_MEDIA_QUERY = '(hover: none), (pointer: coarse)';

function matches(): boolean {
  return typeof window !== 'undefined' && window.matchMedia(TOUCH_MEDIA_QUERY).matches;
}

/** Erkennt Touch-/Coarse-Pointer-Geräte (iPad, iPhone im Querformat …) zur Laufzeit. */
export function useIsTouchDevice(): boolean {
  const [isTouch, setIsTouch] = useState(matches);

  useEffect(() => {
    const mql = window.matchMedia(TOUCH_MEDIA_QUERY);
    const onChange = () => setIsTouch(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isTouch;
}
